import angularModule from 'FrontRoyalApiErrorHandler/angularModule/scripts/front_royal_api_error_handler';
import template from 'FrontRoyalApiErrorHandler/angularModule/views/logged_out.html';
import cacheAngularTemplate from 'cacheAngularTemplate';

const templateUrl = cacheAngularTemplate(angularModule, template);

angularModule.directive('apiErrorLoggedOut', [
    '$injector',

    /*
            This error modal is shown if a user is somehow signed out
            during a session and an api call fails with a 401 not_logged_in
            error.

            We show a sign-in form so the user can log back in. Once they're
            authenticated, the failed request is retried and they continue on
            without reloading the page.
        */

    $injector => {
        const $rootScope = $injector.get('$rootScope');
        const HttpQueue = $injector.get('HttpQueue');
        const reactRouterBridge = $injector.get('reactRouterBridge');

        return {
            restrict: 'E',
            templateUrl,
            scope: {
                resolve: '<',
                response: '<',
                reject: '<',
            },
            link(scope) {
                // set the target so that after login we are forwarded back to the same place
                reactRouterBridge.search('target', 'NONE');

                const stopListeningForLoginSuccess = $rootScope.$on('validation-responder:login-success', () => {
                    stopListeningForLoginSuccess();
                    HttpQueue.retry(scope.response.config).then(
                        response => {
                            scope.resolve(response);
                        },
                        response => {
                            scope.reject(response);
                        },
                    );
                });

                scope.$on('$destroy', () => {
                    stopListeningForLoginSuccess();
                });
            },
        };
    },
]);
